-<template>
    <v-container :fluid="$vuetify.breakpoint.md">
        <v-row justify="center">
            <v-col cols="12">
                <v-card flat color="transparent" class="mb-14">
                    <v-card-text>
                        <v-row justify="center">
                            <v-col cols="12" class="pa-1">
                                <v-card color="bg" class="mb-4" style="border-radius: 10px;">
                                    <v-card-text>
                                        <v-list class="pa-0" color="transparent">
                                            <v-list-item class="pa-0" three-line>
                                                <v-list-item-avatar class="my-0 align-self-center" size="80" style="border: 1px solid #0D93A5">
                                                    <img :src="'/' + ( user.photo ? user.photo : 'img/photo-default.jpg' )" :alt="user.name + ' ' + user.lname"/>
                                                </v-list-item-avatar>
                                                <v-list-item-content class="pa-0 align-self-center">
                                                    <v-list-item-title :class="'font-weight-bold mb-1 text-sm-h6 text-lg-h5 ' + ($vuetify.theme.dark ? 'secondary' : 'primary') + '--text'">
                                                        {{ user.name + ' ' + user.lname }}
                                                    </v-list-item-title>
                                                    <v-list-item-subtitle :class="'font-weight-bold mb-1 ' + ($vuetify.theme.dark ? 'secondary' : 'primary') + '--text'">
                                                        ID: {{ user.id === null ? '' : (user.id).toString().padStart(5, 0) }}
                                                    </v-list-item-subtitle>
                                                    <v-list-item-content
                                                        :class="(user.status === 103 ? 'success' : (user.status === 102 ? 'info' : (user.status === 104 ? 'error' : 'tertiary'))) + '--text d-inline-block py-0 font-weight-bold mb-1'">
                                                        {{ user.status === 103 ? 'Verificado' : (user.status === 102 ? 'En Revisión' : (user.status === 104 ? 'Bloqueado' : 'Sin Verificar')) }}
                                                        <v-icon small :color="(user.status === 103 ? 'success' : (user.status === 102 ? 'info' : (user.status === 104 ? 'error' : 'tertiary')))">
                                                            {{ 'mdi-' + (user.status === 103 ? 'check' : (user.status === 102 ? 'sync' : (user.status === 104 ? 'close' : 'alert'))) + '-circle' }}
                                                        </v-icon>
                                                    </v-list-item-content>
                                                    <v-list-item-subtitle :class="'font-weight-bold mb-1 ' + ($vuetify.theme.dark ? 'secondary' : 'primary') + '--text'">
                                                        IP: {{ user.ip }}
                                                    </v-list-item-subtitle>
                                                </v-list-item-content>
                                                <v-btn small depressed :color="($vuetify.theme.dark ? 'secondary primary--text' : 'primary')" fab to="/profile/edit">
                                                    <v-icon>mdi-{{ user.status === 103 ? 'eye' : 'pencil' }}</v-icon>
                                                </v-btn>
                                            </v-list-item>
                                        </v-list>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <template v-for="item in actions">
                                <v-col cols="6" md="4" lg="3" class="pa-1">
                                    <v-card dark color="primary" class="px-0 text-center" :to="item.link">
                                        <v-icon class="pt-3" size="42">mdi-{{ item.icon }}</v-icon>
                                        <v-card-subtitle class="px-0 py-1 d-block">{{ item.name }}</v-card-subtitle>
                                    </v-card>
                                </v-col>
                            </template>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-footer fixed tile padless class="text-center mb-14">
            <v-col cols="12">
                <v-btn block @click="logout()" color="error" large style="display:inline-grid;white-space:normal;">
                    <v-icon class="pr-2">mdi-logout</v-icon>
                    Cerrar Sesión
                </v-btn>
            </v-col>
        </v-footer>
    </v-container>
</template>

<script>
    import axios from 'axios';

    export default {
        name: "ProfileView",
        props: [ 'user' ],
        data: () => ({
            loading: true,
            actions: [
                { name: "Mis Datos", icon: "account-details", link: "/profile/edit" },
                { name: "Seguridad", icon: "account-lock", link: "/profile/password" },
                //{ name: "Recompensas", icon: "hand-coin", link: "/rewards" },
                //{ name: "Ayuda", icon: "tooltip-question", link: "/profile/help" },
                //{ name: "Sobre Nosotros", icon: "information", link: "/profile/about" },
                { name: "Política de Cookies", icon: "script-text", link: "/profile/cookies" },
                { name: "Tratamiento de Datos", icon: "script-text", link: "/profile/data" },
                { name: "Política de Privacidad", icon: "script-text", link: "/profile/privacy" },
                { name: "Términos & Condiciones", icon: "script-text", link: "/profile/terms" }
            ]
        }),
        methods: {
            async logout() {
                await this.$store.dispatch("logout");
                this.$toast.info('Has cerrado sesion correctamente.', { icon: 'mdi-information' });
                await this.$router.push({name: "Login"});
            }
        }
    }
</script>

<style scoped>

</style>
